'use strict';

var _ = require('lodash');
var urlJoin = require('url-join');
var sendGet = require('./send-action').get;
var userEndpointMixin = require('./user-endpoint-mixin');

function Partner(options) {
  this._baseUrl = options.baseUrl;
}

Partner.prototype.get = function(options) {
  var uri = urlJoin(this._baseUrl, this._usersUrl, 'partner/');

  if (options && options.propertiesLocale) {
    uri = urlJoin(uri, '?properties_locale=' + options.propertiesLocale);
  }

  if (options && options.sitePropertiesLocale) {
    uri = urlJoin(uri, '?site_properties_locale=' + options.sitePropertiesLocale);
  }
  // add trailing slash before parameters
  uri = uri.replace('?', '/?');
  return sendGet(uri);
};

Partner.prototype.getById = function(id, options) {
  if (!id) {
    throw new Error('Expected `id` to be set');
  }

  var uri = urlJoin(this._baseUrl, `pb/partners/${id}/`);

  if (options && options.propertiesLocale) {
    uri = urlJoin(uri, '?properties_locale=' + options.propertiesLocale);
  }

  if (options && options.sitePropertiesLocale) {
    uri = urlJoin(uri, '?site_properties_locale=' + options.sitePropertiesLocale);
  }
  // add trailing slash before parameters
  uri = uri.replace('?', '/?');
  return sendGet(uri);
};

Partner.prototype.getPackages = function (partnerId) {
  if (!partnerId) {
    throw new Error('Expected `id` to be set');
  }

  var uri = urlJoin(this._baseUrl, 'pb/partners', partnerId, 'packages/');

  return sendGet(uri);
};

_.assignIn(Partner.prototype, userEndpointMixin);

module.exports = Partner;
